import { render } from "./SoftSelect.vue?vue&type=template&id=34ace6dd"
import script from "./SoftSelect.vue?vue&type=script&lang=js"
export * from "./SoftSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__